<template>
  <mt-swipe class="index-banner" :class="{'full':full}" v-bind:style="'width:'+getBannerStyle.width+'px;height:'+getBannerStyle.height+'px'" :showIndicators="isShowIndicators">
    <mt-swipe-item v-for="(item, index) in items" :key="index">
      <div class="banner-wrapper"><img class="banner-image" v-lazy="item.adv_code" v-if='item.adv_code' @click="goAdUrl(item)"></div>
    </mt-swipe-item>
  </mt-swipe>
<!--  <div class="common-popup-content">
      <video style="width:100%;height:100%" autoplay="autoplay" controls="controls" controlslist="nodownload"/>
  </div> -->
</template>

<script>
export default {
  name: 'IndexBanner',
  data () {
    return {
    }
  },
  props: ['items','full'],
  computed: {
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      let itemHeight = width * (300 / 702)
      return {
        width: itemWidth,
        height: itemHeight
      }
    },
    isShowIndicators () {
      if (this.items && this.items.length > 1) {
        return true
      }
      return false
    }
  },
  methods: {
    goAdUrl (item) {
      switch (item.adv_type) {
        case 'goods':
          this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.adv_typedate } })
          break
        case 'store':
          this.$router.push({ name: 'HomeStoredetail', query: { id: item.adv_typedate } })
          break
        case 'article':
          this.$router.push({ name: 'HomeArticledetail', query: { article_id: item.adv_typedate } })
          break
        case 'url':
          window.location.href=item.adv_typedate
          break
      }
    }
  }
}
</script>
<style lang="scss">
  .index-banner{
    .mint-swipe-indicators{bottom:.4rem;
      .mint-swipe-indicator{opacity: 1;background: #D8D8D8;
        &.is-active{background: $primaryColor}
      }
    }
  }
</style>
<style scoped lang="scss">
  .index-banner{padding-top:$modelSpace;padding-bottom:1.5rem;background: #fff;
    .banner-wrapper{position:absolute;top:0;bottom:0;left:$pageSpace;right:$pageSpace;
      .banner-image{width:100%;height:100%;border-radius:.4rem;}
    }
  }
  .index-banner.full{padding-top:0;
    .banner-wrapper{left:0;right:0;
      .banner-image{border-radius:0}
    }
  }
</style>
